import { Callout, LoadingRegion, Skeleton } from '@apovisio/ui';
import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';
import { useMe } from './api';

/** Protège l'espace admin : session requise, puis validation TOTP. */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const me = useMe();
  const location = useLocation();

  if (me.isPending) {
    return (
      <main className="app-centered">
        <LoadingRegion label="Vérification de la session">
          <Skeleton width={280} height={20} />
        </LoadingRegion>
      </main>
    );
  }
  if (me.isError) {
    return (
      <main className="app-centered">
        <Callout tone="danger" title="Impossible de vérifier votre session" live="alert">
          Vérifiez votre connexion puis rechargez la page.
        </Callout>
      </main>
    );
  }
  if (!me.data)
    return <Navigate to="/admin/connexion" replace state={{ from: location.pathname }} />;
  if (!me.data.totp.verified) return <Navigate to="/admin/totp" replace />;
  return children;
}
